export { default } from "./EditorTabs";
